import React, { useState } from "react";
import "../css/ModalPopUp.css";
import MasjidKalangSlider from "./slider/MasjidKalangSlider";
import Footer from "../../../../../../Footer";

export default function MasjidKalang() {

  return (
    <div className="modal-img">
        <MasjidKalangSlider/>
        <Footer/>
    </div>
  );
}